import React from "react";

type SizeProps = {
  width?: string;
  height?: string;
};

export default function PromotionIcon(props: SizeProps) {
  const { width = "35px", height = "35px" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Icons / Full / Promo Credit 2</title>
      <g
        id="Icons-/-Full-/-Promo-Credit-2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <circle id="Oval" fill="#26626C" cx="20" cy="20" r="20"></circle>
        <path
          d="M14.7725793,15.305479 C15.9730119,15.3568092 18.6012532,20.7301188 22.6573032,31.4254075 C19.0854767,32.3881722 16.4222954,32.8801506 14.6677595,32.9013427 C12.9132235,32.9225348 10.5037674,32.4918261 7.43939119,31.6092166 C11.1277507,20.6887279 13.5721467,15.2541487 14.7725793,15.305479 Z"
          id="Triangle"
          stroke="#FFFFFF"
          strokeLinejoin="round"
          transform="translate(15.048347, 24.103603) rotate(-133.000000) translate(-15.048347, -24.103603) "
        ></path>
        <path
          d="M15.1408572,14.6777604 C16.7791931,17.6338754 18.2084046,19.6665178 19.4284916,20.7756878 C20.6485786,21.8848578 22.6494746,22.9704949 25.4311798,24.0325991"
          id="Line"
          stroke="#FFFFFF"
          strokeLinecap="square"
          strokeLinejoin="round"
          transform="translate(20.286018, 19.355180) rotate(5.000000) translate(-20.286018, -19.355180) "
        ></path>
        <path
          d="M24.123822,11.1238091 C23.8194374,12.0156265 23.5076094,12.6743827 23.1883381,13.1000779 C22.8690667,13.525773 22.2454108,14.1143286 21.3173704,14.8657446"
          id="Line-2"
          stroke="#FFFFFF"
          strokeLinecap="round"
          transform="translate(22.720596, 12.994777) rotate(5.000000) translate(-22.720596, -12.994777) "
        ></path>
        <path
          d="M28.9250531,15.7269113 C28.1028607,16.0605086 27.4792048,16.3867271 27.0540854,16.7055666 C26.6289659,17.0244062 26.00531,17.6336716 25.1831176,18.5333629"
          id="Line-2"
          stroke="#FFFFFF"
          strokeLinecap="round"
          transform="translate(27.054085, 17.130137) rotate(5.000000) translate(-27.054085, -17.130137) "
        ></path>
        <line
          x1="26.7583085"
          y1="13.1914892"
          x2="23.016373"
          y2="16.9334247"
          id="Line-2"
          stroke="#FFFFFF"
          strokeLinecap="round"
          transform="translate(24.887341, 15.062457) rotate(5.000000) translate(-24.887341, -15.062457) "
        ></line>
        <circle
          id="Oval"
          stroke="#FFFFFF"
          strokeWidth="0.5"
          transform="translate(21.730374, 8.212857) rotate(5.000000) translate(-21.730374, -8.212857) "
          cx="21.730374"
          cy="8.21285727"
          r="1"
        ></circle>
        <circle
          id="Oval"
          stroke="#FFFFFF"
          strokeWidth="0.5"
          transform="translate(27.962775, 22.843981) rotate(5.000000) translate(-27.962775, -22.843981) "
          cx="27.9627747"
          cy="22.8439807"
          r="1"
        ></circle>
        <circle
          id="Oval"
          stroke="#FFFFFF"
          strokeWidth="0.5"
          transform="translate(17.595014, 12.546346) rotate(5.000000) translate(-17.595014, -12.546346) "
          cx="17.5950138"
          cy="12.5463465"
          r="1"
        ></circle>
        <circle
          id="Oval"
          stroke="#FFFFFF"
          strokeWidth="0.5"
          transform="translate(32.098135, 18.510491) rotate(5.000000) translate(-32.098135, -18.510491) "
          cx="32.098135"
          cy="18.5104915"
          r="1"
        ></circle>
        <circle
          id="Oval"
          stroke="#FFFFFF"
          strokeWidth="0.5"
          transform="translate(29.954625, 10.810501) rotate(5.000000) translate(-29.954625, -10.810501) "
          cx="29.9546251"
          cy="10.8105005"
          r="1"
        ></circle>
        <line
          x1="13.0377504"
          y1="18.1236517"
          x2="20.9893633"
          y2="26.0752646"
          id="Line-5"
          stroke="#FFFFFF"
          strokeLinecap="square"
          transform="translate(16.779686, 21.865587) rotate(5.000000) translate(-16.779686, -21.865587) "
        ></line>
        <line
          x1="10.2879026"
          y1="24.733811"
          x2="14.263709"
          y2="28.7096175"
          id="Line-4"
          stroke="#FFFFFF"
          strokeLinecap="square"
          transform="translate(11.924999, 26.370908) rotate(5.000000) translate(-11.924999, -26.370908) "
        ></line>
        <line
          x1="11.8647877"
          y1="21.6918422"
          x2="17.4776909"
          y2="27.3047454"
          id="Line-4"
          stroke="#FFFFFF"
          strokeLinecap="square"
          transform="translate(14.671239, 24.498294) rotate(5.000000) translate(-14.671239, -24.498294) "
        ></line>
        <g id="Group-2" transform="translate(16.000000, 7.000000)" fill="#FFFFFF">
          <rect id="Rectangle" x="1" y="1" width="2" height="2"></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(45.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(67.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(110.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
        </g>
        <g id="Group-2" transform="translate(24.000000, 7.000000)" fill="#FFFFFF">
          <rect id="Rectangle" x="1" y="1" width="2" height="2"></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(45.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(67.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(110.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
        </g>
        <g id="Group-2" transform="translate(30.000000, 12.000000)" fill="#FFFFFF">
          <rect id="Rectangle" x="1" y="1" width="2" height="2"></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(45.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(67.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(110.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
        </g>
        <g id="Group-2" transform="translate(29.400000, 19.800000)" fill="#FFFFFF">
          <rect id="Rectangle" x="1" y="1" width="2" height="2"></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(45.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(67.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
          <rect
            id="Rectangle"
            transform="translate(2.000000, 2.000000) rotate(110.000000) translate(-2.000000, -2.000000) "
            x="1"
            y="1"
            width="2"
            height="2"
          ></rect>
        </g>
      </g>
    </svg>
  );
}
